import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'
import de from './locales/de'

Vue.use(VueI18n)

// 获取保存的语言设置，默认为中文
const savedLocale = localStorage.getItem('locale') || 'zh'

const i18n = new VueI18n({
  locale: savedLocale, // 默认语言
  fallbackLocale: 'zh', // 如果没有找到翻译，使用中文
  messages: {
    zh,
    en,
    de
  }
})

export default i18n
